import React from 'react'
import { css, cx } from '@emotion/css'

const headingCss = (margin: number) => css`
  margin: ${margin}px 0;
`

interface Props {
  readonly className?: string
  readonly children: Array<JSX.Element | string> | JSX.Element | string
}

const renderHeading = (
  Tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  baseStyle: string | undefined,
  { className, ...props }: Props
) => <Tag className={cx(baseStyle, className)} {...props} />

const h1css = headingCss(32)
export function H1(props: Props) {
  return renderHeading('h1', h1css, props)
}

const h2css = headingCss(16)
export function H2(props: Props) {
  return renderHeading('h2', h2css, props)
}

const h3css = headingCss(8)
export function H3(props: Props) {
  return renderHeading('h3', h3css, props)
}

const h4css = headingCss(4)
export function H4(props: Props) {
  return renderHeading('h4', h4css, props)
}

const h5css = headingCss(2)
export function H5(props: Props) {
  return renderHeading('h5', h5css, props)
}

const h6css = headingCss(0)
export function H6(props: Props) {
  return renderHeading('h6', h6css, props)
}
